<div class="row py-2">
  @for (option of optionsList(); track option; let i = $index) {
    <div class="col-md-4">
      <div class="custom-control custom-radio custom-control-inline custom-control-lg mb-2" [attr.aria-describedby]="errorId">
        <label class="custom-control-label" [for]="id + '_' + i">
          <input
            type="radio"
            [id]="id + '_' + i"
            class="custom-control-input"
            [name]="field.name || id"
            [class.is-invalid]="showError"
            [attr.value]="option.value"
            [value]="option.value"
            [formControl]="formControl"
            [formlyAttributes]="field"
            />
          {{ option.label }}
        </label>
      </div>
    </div>
  }
</div>
